import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';
import { AnonymisationLogEntityType } from '../types';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'anonymizedAt',
    label: 'Anonimisation date',
    sortable: false,
  },
  {
    name: 'daysPeriod',
    label: 'Interval (days)',
    sortable: false,
  },
  {
    name: 'entityType',
    label: 'Type',
    sortable: false,
  },
  {
    name: 'entityId',
    label: 'ID',
    sortable: false,
  },
];

export const columnsLabels = {
  entityType: 'Type',
};

export const schema = {
  entityType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'entityType',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'entityType',
        title: 'Cash Collection',
        value: AnonymisationLogEntityType.CASH_COLLECTION,
      },
      {
        name: 'entityType',
        title: 'Orders',
        value: AnonymisationLogEntityType.CASH_COLLECTION_BENEFICIARY,
      },
    ],
  },
];
